import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function ErrorPage() {
    return (
        <>
            <Helmet>
                <title>Page Not Found | Georgi Dobromirov</title>
                <meta name="description" content="Page Not Found." />
            </Helmet>

            <div className="error">
                <h1>404 - Page Not Found</h1>
                <p>The page you are looking for does not exist.</p>
                <Link to="/" className="error_link">BACK TO HOME</Link>
            </div>
        </>
    );
}

export default ErrorPage;
